import { useEffect, useRef, useState } from "react";
import { ShieldCheck, ArrowRight, CheckCircle } from "lucide-react";
import heroImage from "../../assets/Provinyx-authenticator.png";
import DemoModal from "../Demomodal"; // adjust path if needed

function AuthHero() {
  const sectionRef = useRef(null);
  const [visible,   setVisible]   = useState(false);
  const [demoOpen,  setDemoOpen]  = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section
        id="authenticator"
        ref={sectionRef}
        className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-900 via-blue-900 to-black relative overflow-hidden"
      >
        {/* Glowing blobs background */}
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="absolute top-20 left-10 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-pulse" />
          <div
            className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          />
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">

            {/* LEFT CONTENT */}
            <div
              style={{
                transform: visible ? "translateX(0)" : "translateX(-60px)",
                opacity: visible ? 1 : 0,
                transition: "transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.7s ease",
              }}
            >
              <div className="inline-flex items-center px-4 py-2 bg-blue-500/20 backdrop-blur text-blue-300 rounded-full mb-6 border border-blue-500/30">
                <ShieldCheck className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">Provinyx Authenticator</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Eliminate Counterfeits with{" "}
                <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                  Blockchain Security
                </span>
              </h1>

              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Protect your brand, products, and customers with enterprise-grade
                authentication technology. Our Secure by Design™ methodology
                combines physical and digital security for unbreakable product
                verification.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                {/* ── Request Demo → opens DemoModal on tab 0 ── */}
                <button
                  onClick={() => setDemoOpen(true)}
                  className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all duration-300 flex items-center justify-center gap-2 group shadow-xl will-change-transform"
                >
                  Request Demo
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                {/* <button className="bg-white/10 backdrop-blur text-white px-8 py-4 rounded-lg border-2 border-white/30 hover:bg-white/20 transition-all duration-300">
                  Learn More
                </button> */}
              </div>
            </div>

            {/* RIGHT */}
            <div
              className="relative"
              style={{
                transform: visible ? "translateX(0)" : "translateX(60px)",
                opacity: visible ? 1 : 0,
                transition: "transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.15s, opacity 0.7s ease 0.15s",
              }}
            >
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={heroImage}
                  loading="lazy"
                  alt="Smartphone scanning product authentication"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent" />
              </div>

              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-2xl p-6 border border-gray-200">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <CheckCircle className="w-7 h-7 text-green-600" />
                  </div>
                  <div>
                    <div className="font-bold text-black">Verified Authentic</div>
                    <div className="text-sm text-gray-600">Product ID: #DPP-2024-1337</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Demo Modal */}
      {demoOpen && <DemoModal initialTab={0} onClose={() => setDemoOpen(false)} />}
    </>
  );
}

export default AuthHero;